import axios from 'axios';
import {
    MDBAlert,
    MDBBtn,
    MDBInput,
    MDBSelect,
    MDBSwitch,MDBSpinner
} from "mdb-react-ui-kit";
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from "react";
import { useParams } from 'react-router-dom';
import { UserProfileContext } from '../context/UserProfileProvider';
import { DomainContext } from '../context/DomainProvider';
import { GeographyContext } from '../context/GeographyProvider';
const AddressForm = ({ showAddressModal, handleAddressModal, addresses = [], setIsAddressFormSubmitted, addressToUpdate, updateAddressId, addressesId, addressIdForUserProfile }) => {
    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertColor, setAlertColor] = useState('');
    const baseUrl = process.env.REACT_APP_INVENTORY_URL;
    const { stateOptions=[], setStateOptions} = useContext(GeographyContext);
    const { setAddresses} = useContext(UserProfileContext);
    const {setDomainData} = useContext(DomainContext);
    const { domainId } = useParams();
    const [isBilling, setIsBilling] = useState(true);
    const [isShipping, setIsShipping] = useState(true);   
    const [waitToSave, setWaitToSave] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const initialFormValues = addressToUpdate ? [addressToUpdate] : [{
        type: '',
        street: '',
        locality: '',
        stateOrProvince: '',
        postalCode: '',
        countryName: '',
        isBilling: true,
        isShipping: true,
    }];
    const [localAddresses, setLocalAddresses] = useState(initialFormValues);

    const addAddress = () => {
        setLocalAddresses(prev => [...prev, {
            street: '',
            locality: '',
            stateOrProvince: '',
            postalCode: '',
            countryName: '',
            isBilling: true,
            isShipping: true,

        }]);
    };
    useEffect(() => {
        if (addressToUpdate) {
            setLocalAddresses([addressToUpdate]);  // Ensure it's always an array
        } else {
            setLocalAddresses([{
                type: '',
                street: '',
                locality: '',
                stateOrProvince: '',
                postalCode: '',
                countryName: '',
                isBilling: true,
                isShipping: true,
            }]);
        }
    }, []);

    const removeAddress = (indexToRemove) => {
        setLocalAddresses(prevAddresses =>
            prevAddresses.filter((_, index) => index !== indexToRemove)
        );
    };
    const handleInputChange = (e, index) => {
        const { name, value } = e.target;
        const list = [...localAddresses];
        list[index][name] = value;
        setLocalAddresses(list);
    };
    const hasDuplicateAddressType = (addresses) => {
        const types = addresses?.map(address => address.type);
        return new Set(types).size !== types.length;
    };

    const handleFormSubmit = (event) => {
        setWaitToSave(true);
        event.preventDefault();
        if (hasDuplicateAddressType(localAddresses)) {
            setAlertMessage('Duplicate address types are not allowed');
            setAlertColor('danger');
            setShowAlert(true);
            setTimeout(() => setShowAlert(false), 5000);
            setWaitToSave(false);
            return;
        }

        const addressPurposes = new Set();
        if (isBilling) addressPurposes.add("Billing");
        if (isShipping) addressPurposes.add("Shipping");
        const addressPurposesArray = Array.from(addressPurposes);
        const augmentedAddresses = localAddresses.map(address => ({
            ...address,
            addressPurposes: addressPurposesArray,
        }));
        const urlFormation = addressIdForUserProfile ? `${baseUrl}/addresses/${addressIdForUserProfile}` : (addressesId && domainId) ? `${baseUrl}/addresses/domain/${addressesId}` : domainId ? `${baseUrl}/addresses/domain/${domainId}` : `${baseUrl}/addresses`;


        const axiosConfig = {
            method: addressesId ? 'put' : 'post',
            url: urlFormation,
            data: augmentedAddresses
        };

        axios(axiosConfig)
            .then(response => {
                if (response.status === 200 || response.status === 201) {

                    setDomainData({
                        addressIds: [response.data.id]
                    });

                    const updatedAddresses = response.data?.addressSet ? response.data.addressSet : response.data;
                    setAddresses && setAddresses(updatedAddresses);
                    setAddresses && showAddressModal ? setAddresses(response.data) : setAddresses(response.data.addressSet);
                    showAddressModal && !showAddressModal && updateAddressId && updateAddressId(response.data.id);
                    // showAddressModal && setIsAddressEmpty(false);
                    setAlertMessage('Addresses have been saved');
                    setAlertColor('success');
                    setShowAlert(true);
                    setTimeout(() => {
                        setShowAlert(false);
                        handleAddressModal && handleAddressModal();
                        showAddressModal && setLocalAddresses([{
                            type: '',
                            street: '',
                            locality: '',
                            stateOrProvince: '',
                            postalCode: '',
                            countryName: '',
                            isBilling: false,
                            isShipping: false,

                        }]);

                    }, 3000);
                    !showAddressModal && setIsAddressFormSubmitted(true);
                }
            })
            .catch(error => {
                console.error(error);
                setAlertMessage('An error occurred while saving the addresses');
                setAlertColor('danger');
                setShowAlert(true);
                setTimeout(() => setShowAlert(false), 2000);
            });

            setWaitToSave(false);
    };
    const isFormValid = () => {
        return localAddresses.every((address, i) => {
            const isValid = Object.entries(address).every(([key, field], j) => {
                let isFieldValid;
                if (key === 'isBilling' || key === 'isShipping') {

                    isFieldValid = typeof field === 'boolean';
                } else if (key === 'addressPurposes') {
                    isFieldValid = typeof field === 'object';
                }

                else {
                    isFieldValid = typeof field === 'string' && field.trim() !== '';
                }

                if (!isFieldValid) {
                    console.log(`Invalid field at address ${i}, field ${j} (${key}): `, field);
                }
                return isFieldValid;
            });
            if (!isValid) {
                console.log(`Invalid address at index ${i}: `, address);
            }
            return isValid;
        });
    };
    useEffect(() => {
        if (stateOptions?.length === 0) {
            setIsLoading(true);
            axios.get(`${baseUrl}/countries/name/US/stateCodes`)
                .then(response => {
                    const stateData = response?.data?.map(state => ({
                        text: `${state.name} (${state.code})`,
                        value: state.code,
                    }));
                    setStateOptions(stateData);
                })
                .catch(error => {
                    console.error('There was an error fetching the state codes:', error);
                });

                setIsLoading(false);
        }

    }, []);



    const handleStateChange = (selectedValue, index) => {

        const list = [...localAddresses];
        list[index]['stateOrProvince'] = selectedValue.value;
        setLocalAddresses(list);
    };


    return (
        <section>

            <form className='mt-5' onSubmit={handleFormSubmit}>

                {localAddresses && Array.isArray(localAddresses) && localAddresses.length > 0 && localAddresses.map((address, index) => (
                    <div key={address.id}>
                        {localAddresses?.length > 1 && (
                            <MDBBtn className='me-2' type="button" onClick={() => removeAddress(index)}>
                                Remove Address
                            </MDBBtn>
                        )}
                        <MDBInput className="mb-4" label="Type *" name="type" value={address.type} onChange={(e) => handleInputChange(e, index)} required />
                        <MDBInput className="mb-4" label="Street *" name="street" value={address.street} onChange={(e) => handleInputChange(e, index)} />
                        <MDBInput className="mb-4" label="City *" name="locality" value={address.locality} onChange={(e) => handleInputChange(e, index)} />
                      
            {isLoading ? <MDBSpinner className='mx-2' color='warning'>
              <span className='visually-hidden'>Loading...</span>
            </MDBSpinner> : <MDBSelect
                            name='stateOrProvince'
                            label='State or Province *'
                            id='stateOrProvince'
                            type='text'
                            search
                            className='mt-2 mb-4'
                            data={stateOptions}
                            visibleOptions={5}
                            value={address.stateOrProvince}
                            onValueChange={(selectedValue) => {
                                handleStateChange(selectedValue, index);
                            }}
                        />}
                        
                        <MDBInput className="mb-4" label="Postal Code *" name="postalCode" value={address.postalCode} onChange={(e) => handleInputChange(e, index)} />
                        <MDBInput className="mb-4" label="Country Name *" name="countryName" value={address.countryName} onChange={(e) => handleInputChange(e, index)} />
                        <MDBSwitch className="mb-4" id='isBilling' name="isBilling" checked={isBilling} label='isBilling' onChange={() => setIsBilling(!isBilling)} />
                        <MDBSwitch className="mb-4" id='isShipping' name="isShipping" checked={isShipping} label='isShipping' onChange={() => setIsShipping(!isShipping)} />

                        {(addresses && index < addresses?.length - 1) && <hr className="hr" />}

                        {index < localAddresses.length - 1 && <hr className="hr" />}
                    </div>
                ))}
                {waitToSave ? 
                 <MDBSpinner grow className='mx-2' color='warning'>
                 <span className='visually-hidden'>Loading...</span>
               </MDBSpinner> :  <div className="d-grid gap-2 d-md-block " >
                    <MDBBtn className='me-2' type="button" onClick={addAddress}>
                        Add Address
                    </MDBBtn>

                    <MDBBtn type="submit" disabled={!isFormValid() || waitToSave} >
                        Save
                    </MDBBtn>
                    {showAddressModal && <MDBBtn className='mx-2' color='danger' onClick={() => handleAddressModal()}>close</MDBBtn>}
                </div>}
               
            </form>


            <MDBAlert open={showAlert}
                color={alertColor}
                autohide
                width={800}
                position="top-right"
                offset={50}
                delay={2000}
                appendToBody
            >
                {alertMessage}
            </MDBAlert>


        </section>
    );
};

AddressForm.propTypes = {
    handleAddressModal: PropTypes.func,
    showAddressModal: PropTypes.bool,
    addressesId: PropTypes.string,
    addresses: PropTypes.arrayOf(PropTypes.object),
    setIsAddressFormSubmitted: PropTypes.func,
    addressToUpdate: PropTypes.object,
    updateAddressId: PropTypes.func,
    addressIdForUserProfile: PropTypes.string,
}

export default AddressForm;
